import { render, staticRenderFns } from "./OnlyEmail.vue?vue&type=template&id=4cdbd8da&scoped=true&"
import script from "./OnlyEmail.vue?vue&type=script&lang=js&"
export * from "./OnlyEmail.vue?vue&type=script&lang=js&"
import style0 from "./OnlyEmail.vue?vue&type=style&index=0&id=4cdbd8da&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdbd8da",
  null
  
)

export default component.exports